import React from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import { Title, useGetList } from 'react-admin';

export const Dashboard = () => {
  const { total: totalUsers } = useGetList('users', {
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'id', order: 'ASC' },
    filter: {},
  });

  const { total: totalWorkshops } = useGetList('workshops', {
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'id', order: 'ASC' },
    filter: {},
  });

  const { total: totalBookings } = useGetList('bookings', {
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'id', order: 'ASC' },
    filter: {},
  });

  const { total: totalServices } = useGetList('services', {
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'id', order: 'ASC' },
    filter: {},
  });

  return (
    <div style={{ padding: '20px' }}>
      <Title title="Dashboard" />

      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <Card style={{ minWidth: '200px', flex: 1 }}>
          <CardHeader title="Total Users" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1976d2' }}>
              {totalUsers || 0}
            </div>
          </CardContent>
        </Card>

        <Card style={{ minWidth: '200px', flex: 1 }}>
          <CardHeader title="Total Workshops" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#388e3c' }}>
              {totalWorkshops || 0}
            </div>
          </CardContent>
        </Card>

        <Card style={{ minWidth: '200px', flex: 1 }}>
          <CardHeader title="Total Services" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#f57c00' }}>
              {totalServices || 0}
            </div>
          </CardContent>
        </Card>

        <Card style={{ minWidth: '200px', flex: 1 }}>
          <CardHeader title="Total Bookings" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#7b1fa2' }}>
              {totalBookings || 0}
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader title="Welcome to Workshop Booking Admin" />
        <CardContent>
          <p>
            This admin interface allows you to manage all aspects of the Workshop Booking
            application:
          </p>
          <ul>
            <li>
              <strong>Users:</strong> View and manage user accounts, edit roles, and monitor user
              activity
            </li>
            <li>
              <strong>Workshops:</strong> Verify workshops, edit workshop information, and monitor
              workshop performance
            </li>
            <li>
              <strong>Bookings:</strong> View all bookings, manage status transitions, and resolve
              disputes
            </li>
            <li>
              <strong>Services:</strong> Review workshop-provided services and manage templates
            </li>
          </ul>
          <p>
            Use the navigation menu on the left to access different sections of the admin interface.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
